import React from "react";

import "./UserDetails.scss";

const UserDetails = (props: any) => {
  if (!props.user) {
    return null;
  }
  return (
    <div className="UserDetails-container Administration-customerDetails">
      <div>
        <b className="UserDetails-infoLabel">First Name:</b>{" "}
        <b className="UserDetails-userDetailsFirstName UserDetails-infoItem">
          {props.user.firstName}
        </b>
      </div>
      <div>
        <b className="UserDetails-infoLabel">Last Name:</b>{" "}
        <b className="UserDetails-userDetailsLastName UserDetails-infoItem">
          {props.user.lastName}
        </b>
      </div>
      <div>
        <b className="UserDetails-infoLabel">Email Address:</b>{" "}
        <b className="UserDetails-userDetailsEmail UserDetails-infoItem">
          {props.user.email}
        </b>
      </div>
      <div>
        <b className="UserDetails-infoLabel">Order Limit:</b>{" "}
        <b className="UserDetails-userDetailsOrderLimit UserDetails-infoItem">
          {props.user.orderLimit}
        </b>
      </div>
      <div>
        <b className="UserDetails-infoLabel">Daily Limit:</b>{" "}
        <b className="UserDetails-userDetailsDailyLimit UserDetails-infoItem">
          {props.user.dailyLimit}
        </b>
      </div>
    </div>
  );
};

export default UserDetails;
